<template>
  <div class="tab-control-container" data-test-id="tab-control">
    <div class="tab-control">
      <div class="tab-control__navigation">
        <a
          v-for="tab in tabs"
          :key="tab.id"
          :class="['tab-control__nav-item', { 'tab-control__nav-item--active': tab.isActive }]"
          @click="$emit('update:activeTabId', tab.id)"
          v-data-test-id="`tab-control-nav-item-${tab.id}`"
          >{{ tab.name }}</a
        >
      </div>
      <div class="tab-control__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabControl',

  props: {
    activeTabId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tabs: [],
    }
  },

  watch: {
    activeTabId: 'updateActiveTab',
  },

  mounted() {
    this.tabs = this.$children
    this.updateActiveTab()
  },

  methods: {
    updateActiveTab() {
      this.tabs.forEach(tab => {
        tab.isActive = tab.id === this.activeTabId
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-control-container {
  position: relative;
}
.tab-control {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  &__navigation {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    border-bottom: 1px solid $c-grey-light-1;

    @include min-screen($mq-width-small) {
      justify-content: flex-start;
    }
  }

  &__nav-item {
    cursor: pointer;
    text-transform: uppercase;
    font-size: $font-size-normal;
    font-weight: 500;
    padding-bottom: 24px;
    letter-spacing: 2.79px;
    color: $c-grey-mid-1;
    border-bottom: 2px solid transparent;
    transition: color 0.2s, border-color 0.2s;

    &:not(:last-child) {
      margin-right: 64px;
    }

    &--active {
      color: $c-grey-dark-2;
      border-color: $c-green-2;
    }
  }

  &__content {
    min-height: 40vh;
    width: 100%;
  }
}
</style>
